<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>
<form [formGroup]="rejectForm" fxFlexLayout="column" style="width: 100%; margin: 20px 0px;" (ngSubmit)="onConfirm()"
  autocomplete="off" autocomplete="off">
  <div mat-dialog-content>
    <mat-form-field appearance="outline" style="width: 99%;">
      <mat-label>Razón</mat-label>
      <textarea matInput placeholder="Razón del rechazo"
        formControlName="reason"></textarea>
      <mat-error id="requiredTelError" *ngIf="rejectForm.controls['reason'].hasError('required')">
        La Razón es
        <strong>requerida</strong>
      </mat-error>
    </mat-form-field>

  </div>

  <div mat-dialog-actions>
    <button mat-button type="button" (click)="onDismiss()">Cancelar</button>
    <button mat-raised-button color="primary" type="submit">Aceptar</button>
  </div>
</form>